export type WorkType = "movie" | "series";

export interface Work {
  id: string;
  title: string;
  enTitle: string;
  type: WorkType;
  year: number;
  releaseDate: string;
  role: string;
  roleType: string;
  director: string;
  genre: string[];
  synopsis: string;
  cover: string;
  duration: string;
  rating: number;
  popularity: number;
}

export const works: Work[] = [
  {
    id: "night-train",
    title: "夜行列车",
    enTitle: "Night Train",
    type: "movie",
    year: 2024,
    releaseDate: "2024-11-08",
    role: "水野 澪",
    roleType: "主演",
    director: "黑泽和树",
    genre: ["悬疑", "剧情"],
    synopsis:
      "末班列车驶离东京后的第七分钟，车厢里只剩下六名乘客。水野澪在失物招领处发现一只无人认领的旧皮箱，箱内的信件指向十五年前一桩未结的失踪案。随着列车穿过一座又一座无人的小站，她开始怀疑同行者中有人一直在等待她打开那只箱子。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20of%20a%20lone%20woman%20in%20a%20long%20dark%20coat%20standing%20on%20an%20empty%20night%20train%20platform%2C%20warm%20amber%20lamplight%20pooling%20on%20wet%20ground%2C%20deep%20navy%20blue%20shadows%2C%20rain%20mist%2C%20moody%20atmospheric%20lighting%2C%20elegant%20vertical%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=800&seq=work-night-train&orientation=portrait",
    duration: "128 分钟",
    rating: 8.6,
    popularity: 96,
  },
  {
    id: "letters-of-the-tide",
    title: "潮汐之信",
    enTitle: "Letters of the Tide",
    type: "movie",
    year: 2023,
    releaseDate: "2023-09-15",
    role: "三浦 千夏",
    roleType: "主演",
    director: "白石凛",
    genre: ["爱情", "剧情"],
    synopsis:
      "在濑户内海的小岛上，千夏继承了祖母留下的旧邮局。她发现一批从未寄出的信，收件人全都写着同一个名字。为了把信送到，她开始逐一拜访岛上的老人，也重新拼起了一段被海水冲淡的往事。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20woman%20seen%20from%20behind%20holding%20a%20stack%20of%20old%20letters%20by%20a%20calm%20harbor%20at%20dusk%2C%20soft%20amber%20sunset%20haze%2C%20deep%20navy%20sea%2C%20gentle%20melancholy%20mood%2C%20elegant%20vertical%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=800&seq=work-tide-letters&orientation=portrait",
    duration: "116 分钟",
    rating: 8.9,
    popularity: 92,
  },
  {
    id: "white-corridor",
    title: "白色回廊",
    enTitle: "The White Corridor",
    type: "series",
    year: 2023,
    releaseDate: "2023-04-21",
    role: "相泽 玲",
    roleType: "主演",
    director: "森田圭",
    genre: ["医疗", "剧情"],
    synopsis:
      "地方医院的重症监护室有一条被称为「白色回廊」的通道。新人医生相泽玲在这里第一次直面生死抉择，也第一次意识到，走廊尽头那扇门后藏着的不只是病人，还有整个医院不愿提及的过去。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20long%20bright%20hospital%20corridor%20with%20a%20single%20woman%20silhouette%20walking%20away%2C%20cool%20white%20light%20mixed%20with%20warm%20amber%20lamp%2C%20deep%20navy%20accents%2C%20quiet%20tension%2C%20elegant%20vertical%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=800&seq=work-white-corridor&orientation=portrait",
    duration: "全 10 集",
    rating: 8.7,
    popularity: 94,
  },
  {
    id: "tokyo-twelve-hours",
    title: "东京十二时",
    enTitle: "Tokyo Twelve Hours",
    type: "movie",
    year: 2022,
    releaseDate: "2022-12-02",
    role: "神谷 瞳",
    roleType: "特别出演",
    director: "高梨悠",
    genre: ["犯罪", "悬疑"],
    synopsis:
      "一通打错的电话，让一名普通的夜间电台主播卷入了十二小时内必须破解的连环案。她只能靠声音辨认每一个来电者，而其中一个人，正在直播间的楼下。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20neon%20lit%20Tokyo%20backstreet%20at%20midnight%20with%20a%20woman%20walking%20through%20warm%20amber%20signage%20glow%2C%20deep%20navy%20blue%20night%20sky%2C%20rain%20reflections%2C%20tense%20urban%20thriller%20mood%2C%20elegant%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=work-tokyo-twelve&orientation=portrait",
    duration: "134 分钟",
    rating: 8.2,
    popularity: 88,
  },
  {
    id: "letters-from-kirishima",
    title: "雾岛来信",
    enTitle: "Letters from Kirishima",
    type: "movie",
    year: 2022,
    releaseDate: "2022-06-18",
    role: "藤井 沙耶",
    roleType: "主演",
    director: "白石凛",
    genre: ["剧情", "家庭"],
    synopsis:
      "沙耶带着母亲留下的相机回到雾岛，替她完成一本未出版的摄影集。在山间雾气与温泉蒸汽之间，她慢慢读懂了母亲镜头里始终缺席的那个人。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20misty%20green%20mountain%20valley%20with%20a%20woman%20holding%20a%20vintage%20camera%2C%20soft%20morning%20fog%2C%20warm%20amber%20sunlight%20breaking%20through%2C%20deep%20navy%20pine%20shadows%2C%20serene%20atmosphere%2C%20elegant%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=work-kirishima&orientation=portrait",
    duration: "121 分钟",
    rating: 8.4,
    popularity: 83,
  },
  {
    id: "last-chapter-of-summer",
    title: "夏日终章",
    enTitle: "The Last Chapter of Summer",
    type: "movie",
    year: 2021,
    releaseDate: "2021-08-27",
    role: "宫下 葵",
    roleType: "主演",
    director: "黑泽和树",
    genre: ["青春", "剧情"],
    synopsis:
      "高中最后一个暑假，四个朋友约定在废弃的礼堂里完成一部电影。当夏天结束，他们发现真正需要告别的，并不是那间礼堂。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20teenage%20girl%20standing%20in%20an%20abandoned%20wooden%20school%20auditorium%20with%20sunlight%20streaming%20through%20dusty%20windows%2C%20warm%20amber%20beams%2C%20deep%20navy%20shadows%2C%20nostalgic%20summer%20mood%2C%20elegant%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=work-summer-chapter&orientation=portrait",
    duration: "108 分钟",
    rating: 8.5,
    popularity: 86,
  },
  {
    id: "silent-testimony",
    title: "静默的证词",
    enTitle: "Silent Testimony",
    type: "series",
    year: 2021,
    releaseDate: "2021-01-14",
    role: "桐生 遥",
    roleType: "主演",
    director: "森田圭",
    genre: ["律政", "悬疑"],
    synopsis:
      "一名专攻无声证人的辩护律师，接手了一桩所有人都认为已经结束的案件。她要证明的不是嫌疑人无罪，而是一段被刻意忽略的沉默。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20woman%20lawyer%20standing%20in%20an%20empty%20courtroom%20holding%20a%20document%2C%20dramatic%20side%20lighting%2C%20warm%20amber%20highlights%2C%20deep%20navy%20blue%20shadows%2C%20serious%20restrained%20mood%2C%20elegant%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=work-silent-testimony&orientation=portrait",
    duration: "全 8 集",
    rating: 8.8,
    popularity: 90,
  },
  {
    id: "glass-greenhouse",
    title: "玻璃温室",
    enTitle: "The Glass Greenhouse",
    type: "movie",
    year: 2020,
    releaseDate: "2020-10-09",
    role: "小野寺 里佳",
    roleType: "配角",
    director: "高梨悠",
    genre: ["剧情", "悬疑"],
    synopsis:
      "一座终年恒温的玻璃温室里，住着一位从不出门的植物学家。前来修屋顶的年轻人发现，温室里每一种植物都对应着一个人的名字。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20glass%20greenhouse%20glowing%20warm%20amber%20from%20inside%20at%20dusk%2C%20silhouette%20of%20a%20woman%20among%20tall%20plants%2C%20deep%20navy%20blue%20evening%20sky%2C%20mysterious%20quiet%20mood%2C%20elegant%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=work-glass-greenhouse&orientation=portrait",
    duration: "112 分钟",
    rating: 7.9,
    popularity: 71,
  },
  {
    id: "thirty-five-north",
    title: "北纬三十五度",
    enTitle: "35° North",
    type: "movie",
    year: 2019,
    releaseDate: "2019-07-05",
    role: "早川 奈绪",
    roleType: "主演",
    director: "黑泽和树",
    genre: ["公路", "剧情"],
    synopsis:
      "沿着北纬三十五度线自驾的两个人，一路上不断丢掉行李，也不断丢掉原本想要抵达的理由。直到车停在海岸线尽头，他们才决定说出真话。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20woman%20leaning%20on%20a%20vintage%20car%20bonnet%20on%20an%20empty%20coastal%20road%20at%20golden%20hour%2C%20warm%20amber%20sky%2C%20deep%20navy%20ocean%2C%20road%20movie%20mood%2C%20elegant%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=work-thirty-five-north&orientation=portrait",
    duration: "119 分钟",
    rating: 8.1,
    popularity: 76,
  },
  {
    id: "people-under-the-lamp",
    title: "灯下之人",
    enTitle: "People Under the Lamp",
    type: "series",
    year: 2019,
    releaseDate: "2019-03-08",
    role: "川上 美和",
    roleType: "配角",
    director: "森田圭",
    genre: ["群像", "剧情"],
    synopsis:
      "一间开到凌晨三点的旧书店，一盏总是忘记关掉的灯。每一集有一位深夜来客，带着一本不该出现在这里的书。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20small%20old%20bookstore%20window%20glowing%20warm%20amber%20at%20night%20with%20a%20woman%20reading%20inside%2C%20deep%20navy%20street%2C%20rain%20on%20glass%2C%20intimate%20quiet%20mood%2C%20elegant%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=work-lamp-people&orientation=portrait",
    duration: "全 12 集",
    rating: 8.3,
    popularity: 80,
  },
  {
    id: "seven-days-homeward",
    title: "归途七日",
    enTitle: "Seven Days Homeward",
    type: "movie",
    year: 2018,
    releaseDate: "2018-11-16",
    role: "佐仓 千寻",
    roleType: "主演",
    director: "白石凛",
    genre: ["家庭", "剧情"],
    synopsis:
      "父亲去世后，千寻必须在七天内处理完老房子里的所有东西。每丢掉一件物品，她就想起一段被自己改写过记忆的往事。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20woman%20packing%20cardboard%20boxes%20in%20a%20traditional%20Japanese%20house%20with%20tatami%20floor%2C%20warm%20amber%20afternoon%20light%20through%20paper%20screens%2C%20deep%20navy%20shadows%2C%20melancholy%20mood%2C%20elegant%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=work-seven-days&orientation=portrait",
    duration: "126 分钟",
    rating: 8.6,
    popularity: 79,
  },
  {
    id: "echoes-of-spring",
    title: "春日回声",
    enTitle: "Echoes of Spring",
    type: "series",
    year: 2017,
    releaseDate: "2017-04-07",
    role: "冈田 樱",
    roleType: "主演",
    director: "高梨悠",
    genre: ["爱情", "剧情"],
    synopsis:
      "一位听力逐渐衰退的钢琴调律师，与一位从不说谎的录音师相遇。他们用一台旧录音机，把整个春天留了下来。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20woman%20tuning%20an%20upright%20piano%20in%20a%20sunlit%20room%20with%20cherry%20blossoms%20outside%20the%20window%2C%20soft%20warm%20amber%20light%2C%20deep%20navy%20shadows%2C%20gentle%20romantic%20mood%2C%20elegant%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=work-spring-echoes&orientation=portrait",
    duration: "全 11 集",
    rating: 8.0,
    popularity: 73,
  },
  {
    id: "after-the-rain-stops",
    title: "雨停之后",
    enTitle: "After the Rain Stops",
    type: "movie",
    year: 2016,
    releaseDate: "2016-09-23",
    role: "野本 由纪",
    roleType: "配角",
    director: "黑泽和树",
    genre: ["剧情"],
    synopsis:
      "一场持续四十天的雨让小镇停摆。便利店店员、邮差和一位不肯回家的老人，在同一个屋檐下等雨停，也等一个说法。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20rainy%20small%20town%20street%20with%20a%20woman%20holding%20a%20clear%20umbrella%20under%20warm%20amber%20shop%20light%2C%20wet%20reflections%2C%20deep%20navy%20blue%20overcast%20sky%2C%20quiet%20melancholy%20mood%2C%20elegant%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=800&seq=work-after-rain&orientation=portrait",
    duration: "104 分钟",
    rating: 7.8,
    popularity: 65,
  },
  {
    id: "first-snow",
    title: "初雪记",
    enTitle: "First Snow",
    type: "movie",
    year: 2015,
    releaseDate: "2015-12-11",
    role: "长谷川 雪",
    roleType: "主演",
    director: "白石凛",
    genre: ["剧情", "爱情"],
    synopsis:
      "在北方小镇的第一场雪落下之前，雪要替祖母送完最后一批年贺状。她在雪地里走过一条又一条街，也第一次看清了这座小镇的样子。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20woman%20in%20a%20wool%20coat%20walking%20through%20a%20snowy%20Japanese%20village%20street%20at%20dusk%2C%20warm%20amber%20window%20lights%2C%20deep%20navy%20blue%20snowfall%2C%20tender%20wintry%20mood%2C%20elegant%20vertical%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=800&seq=work-first-snow&orientation=portrait",
    duration: "113 分钟",
    rating: 8.2,
    popularity: 68,
  },
];

export const filmStills: string[] = [
  "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20rain%20streaked%20train%20window%20at%20night%20with%20warm%20amber%20station%20lights%20passing%20outside%2C%20deep%20navy%20interior%20shadows%2C%20reflective%20glass%2C%20moody%20atmospheric%20photography%2C%20no%20people%2C%20subtle%20grain&width=1200&height=800&seq=still-train-window&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20quiet%20fishing%20harbor%20at%20dusk%20with%20small%20boats%20and%20warm%20amber%20lamps%20reflecting%20on%20calm%20water%2C%20deep%20navy%20blue%20sky%2C%20soft%20haze%2C%20wide%20composition%2C%20subtle%20film%20grain&width=1200&height=800&seq=still-harbor-dusk&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20empty%20theatre%20stage%20with%20a%20single%20warm%20amber%20spotlight%20and%20deep%20navy%20velvet%20curtains%2C%20dust%20in%20the%20air%2C%20dramatic%20theatrical%20atmosphere%2C%20wide%20composition%2C%20subtle%20film%20grain&width=1200&height=800&seq=still-empty-stage&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20cozy%20old%20bookstore%20interior%20at%20night%20lit%20by%20warm%20amber%20lamps%2C%20tall%20wooden%20shelves%2C%20deep%20navy%20shadows%20in%20the%20aisles%2C%20intimate%20quiet%20mood%2C%20wide%20composition%2C%20subtle%20film%20grain&width=1200&height=800&seq=still-old-bookstore&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20long%20empty%20hospital%20corridor%20with%20cool%20white%20light%20and%20one%20warm%20amber%20lamp%20at%20the%20far%20end%2C%20deep%20navy%20shadows%2C%20clinical%20calm%20tension%2C%20wide%20composition%2C%20subtle%20film%20grain&width=1200&height=800&seq=still-hospital-corridor&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20snowy%20Japanese%20village%20street%20at%20dusk%20with%20warm%20amber%20window%20lights%20and%20soft%20falling%20snow%2C%20deep%20navy%20blue%20tones%2C%20tranquil%20wintry%20atmosphere%2C%20wide%20composition%2C%20subtle%20film%20grain&width=1200&height=800&seq=still-snow-village&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20rainy%20narrow%20town%20street%20at%20night%20with%20warm%20amber%20shop%20signs%20and%20wet%20reflections%2C%20deep%20navy%20blue%20overcast%20shadows%2C%20lonely%20atmosphere%2C%20wide%20composition%2C%20subtle%20film%20grain&width=1200&height=800&seq=still-rain-street&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20abandoned%20wooden%20school%20auditorium%20with%20warm%20amber%20sunbeams%20cutting%20through%20dusty%20air%20and%20empty%20chairs%2C%20deep%20navy%20shadows%2C%20nostalgic%20summer%20mood%2C%20wide%20composition%2C%20subtle%20film%20grain&width=1200&height=800&seq=still-summer-auditorium&orientation=landscape",
];

export const workGenres: string[] = [
  "剧情",
  "悬疑",
  "爱情",
  "家庭",
  "犯罪",
  "医疗",
  "律政",
  "青春",
  "公路",
  "群像",
];

export const roleTypes: string[] = ["主演", "特别出演", "配角"];

export const workYears: number[] = Array.from(
  new Set(works.map((work) => work.year)),
).sort((a, b) => b - a);

export const getWorkById = (id: string): Work | undefined =>
  works.find((work) => work.id === id);